const statusConst = {
  OPEN: 5,
  PARTIAL: 6,
  CLOSED: 7,
  CUSTOMER: 3,
  APPROVAL_DRAFT: 111,
  APPROVAL_REJECT: 112,
}

const statusColors = [
  { id: 7, name: 'Closed', color: '#11A428' },
  { id: 6, name: 'Partial', color: '#EB9234' },
  { id: 5, name: 'Open', color: '#CF2A28' },
  { id: statusConst.APPROVAL_DRAFT, name: 'Approval Draft', color: '#13A4FF' },
  { id: statusConst.APPROVAL_REJECT, name: 'Reject', color: '#CF2A28' },
]

const closeReasons = [
  { id: 1, slug: 'cancel_order', labelId: 'financeOrder.reason_cancel_order' },
  { id: 2, slug: 'wrong_process', labelId: 'financeOrder.reason_wrong_process' },
  { id: 3, slug: 'other', labelId: 'financeOrder.reason_other' },
]

export { statusConst, statusColors, closeReasons }
